import RoutesBaseController from '../common/routes.base.controller'


class RoutesEditController extends RoutesBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, RouteService, Modal, $translate, $stateParams, BranchService, $scope, DateUtil, SetupService, UserBranchService, $q, 
				TruckService, LocationService, AppConstants, RouteDetailService) {

		super(Auth, $state, User, RouteService, Modal, $translate, $stateParams,TruckService)

		this.TruckService = TruckService
		this.BranchService = BranchService
		this.RouteDetailService = RouteDetailService
		this.model.id = ''
		this.model.day = ''
		this.model.name = ''
		this.model.shortName = ''
		this.model.branch = null
		this.branchId = User.getUser().branchId
		this.model.loggedInUser = User.getUser().id
		this.branch = []
		this.loading = false;
		this.loadingRouteSequence = false;
		this.loadRoutes = []
		this.markerPosition = [];
		this.originationMarker = null;
		this.branchOrigination = null;
		this.originationLocationRequest = 0;
		this.hasACL = {};
		this.DateUtil = DateUtil;
		this.SetupService = SetupService;
		this.UserBranchService = UserBranchService;
		this.LocationService = LocationService;
		this.AppConstants = AppConstants;
		this.map = null;
		this.Modal = Modal;
		this.internalLocationsObj = {
			results: [],
			totalRecords: 0
		};
		this.$scope = $scope;
		this.$q = $q;
		this.days = [
			{ label: this.$translate.instant('location.sun'), value: 'Sun' },
			{ label: this.$translate.instant('location.mon'), value: 'Mon' },
			{ label: this.$translate.instant('location.tues'), value: 'Tue' },
			{ label: this.$translate.instant('location.wed'), value: 'Wed' },
			{ label: this.$translate.instant('location.thurs'), value: 'Thu' },
			{ label: this.$translate.instant('location.fri'), value: 'Fri' },
			{ label: this.$translate.instant('location.sat'), value: 'Sat' },
			{ label: this.$translate.instant('location.hol'), value: 'Hol' }
		];

		this.weekdays = [{
			label: this.$translate.instant('location.mon'),
			value: 'Mon',
			day: 2
		},
		{
			label: this.$translate.instant('location.tues'),
			value: 'Tue',
			day: 3
		},
		{
			label: this.$translate.instant('location.wed'),
			value: 'Wed',
			day: 4
		},
		{
			label: this.$translate.instant('location.thurs'),
			value: 'Thu',
			day: 5
		},
		{
			label: this.$translate.instant('location.fri'),
			value: 'Fri',
			day: 6
		},
		{
			label: this.$translate.instant('location.sat'),
			value: 'Sat',
			day: 7
		},
		{
			label: this.$translate.instant('location.sun'),
			value: 'Sun',
			day: 1
		}]

		this.day = {
			routeId: []
		}

		this.selectedDay = 'Mon';

		this.routeSequenceLocations = [];
		this.routeSequenceLocationData = [];
		this.routeSequenceData = []
		this.sequenceInput = [];
		this.actualLong = "";
		this.actualLat = "";
		this.locationInfo = "";
		this.valutDate = "";
		this.currrentSelectedDay = "";
		this.centerLattitude = "";
		this.centerLongitude = "";
		this.isInitialized = true;
		this.unshiftSelected = true;
		this.assignedTankers = {};
		this.contractDays = [];
		this.currentlyAssignedTankers = {};
		this.isTankerAssignmentChanged = false;
		this.updatedTankerAssignment = {};
		this.previouslyAssignedTanker = {};
		this.newAssignedTanker = {};
		this.selectedLocations = [];
		this.truckOptions = {
			options: [],
			totalRecords: 0
		}
		this.originationOptions = [
			{
				label: 'Branch',
				value: 'BRANCH'
			},
			{
				label: 'Truck',
				value: 'TRUCK'
			},
			{
				label: 'User',
				value: 'USER'
			}
		];
		this.routeDays = ["routeSun", "routeMon", "routeTue", "routeWed", "routeThu", "routeFri", "routeSat", "routeHol"];
		this.dayKeys = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Hol"];
	}

	loadImage(image) {
		this.icon = {
			'REGULAR': 'regular.png',
			'ATM': 'atm.png',
			'BANK': 'bank.png',
			'NO_SHIP_NO_GO': 'nsng.png',
			'INTERNAL': 'internal.png',
			'TRUCK': 'truck.png',
			'TANKER': 'tanker.png',
			'WINDOW': 'window.png',
			'CARRIER': 'carrier.png',
			'ON_CALL': 'oncall.png',
			'LOCKER': 'locker.png',
			'VAULT': 'vault.png',
			'DELIVERY': 'delivery.png'
		}

		let imgURL = this.icon[image]
		return require('../../../assets/images/' + imgURL);
	}

	$onInit() {
		const branchDefer = this.$q.defer();
		this.loading = true
		this.selectedDay = this.$stateParams.day

		this.$q.all([
			this.Service.get(this.$stateParams.id),
			this.UserBranchService.getUserBranches(this.model.loggedInUser),
			this.getPendingRouteChanges(),
		])
			.then((data) => {
				this.loading = false
				this.defaultModel = data[0];
				this.rawId = data[0].id;
				this.model.id = data[0].id;
				this.model.name = data[0].name;
				this.model.shortName = data[0].shortName;
				this.model.active = data[0].active;
				this.model.loadTruck = data[0].loadTruck;
				this.model.beginTime = this.getDate(data[0].beginTime);
				this.model.branch = data[0].branchId;
				this.model.description = data[0].description;
				this.model.holdRoute = data[0].holdRoute;
				this.model.requireDriver = data[0].requireDriver;
				this.model.requireGuard = data[0].requireGuard;
				this.model.specialFlag = data[0].specialFlag;
				this.model.uploadOnEndRouteOnly = data[0].uploadOnEndRouteOnly;
				this.model.autoOptimize = data[0].autoOptimize;
				this.model.autoOpenATMs = data[0].autoOpenATMs;
				this.model.bagoutFlag = data[0].bagoutFlag;
				this.model.requireLoadedAmount = data[0].requireLoadedAmount;
				this.model.requireResidualScan = data[0].requireResidualScan;
				this.model.requireBranchScan = data[0].requireBranchScan;
				this.model.requireThrow = data[0].requireThrow;
				this.model.eventRoute = data[0].eventRoute;
				this.model.shuttleRoute = data[0].shuttleRoute;
				this.model.liabilityLimit = data[0].liabilityLimit;
				this.model.sameForAll = false;
				this.model.autoCheckIn = data[0].autoCheckIn;
				this.model.autoCheckOut = data[0].autoCheckOut;
				this.model.checkOutByTanker = data[0].checkOutByTanker || false;
				this.model.autoCheckInUpdate = data[0].autoCheckInUpdate;
				this.model.autoThrowOnPack = data[0].autoThrowOnPack;
				this.model.NFCScan = data[0].NFCScan;
				this.model.NFCTagId = data[0].NFCTagId;
				this.model.requireTruckScan = data[0].requireTruckScan;
				this.model.bagoutOnTruck = data[0].bagoutOnTruck;
				this.model.routeCutOff = data[0].routeCutOff;
				this.model.routeCutOffTime = this.getDate(data[0].routeCutOffTime);
				this.model.restrictToTruck = data[0].restrictToTruck,
				this.model.restrictTruck = data[0].restrictTruckId ? {
					Key: data[0].restrictTruck.id + ' | ' + data[0].restrictTruck.make, 
					Value: data[0].restrictTruckId,
					locationId: data[0].restrictTruck.locationId
				} : null
				this.restrictTruckChanged();
				this.model.optimizeAfterStop = data[0].optimizeAfterStop;
				this.model.autoSendPickupManifest = data[0].autoSendPickupManifest || false;
				this.model.pickupManifestRecipientEmail = data[0].pickupManifestRecipientEmail;
				this.model.origination = data[0].origination;
				this.model.sendRouteSheet = data[0].sendRouteSheet || false;
				this.model.routeSheetRecipients = data[0].routeSheetRecipients;
				this.model.scanUserItems = data[0].scanUserItems || false;
				this.model.maxRouteTime = this.getDate(data[0].maxRouteTime);
				this.model.maxMileage = data[0].maxMileage;
				this.model.estimatedRouteSpeed = data[0].estimatedRouteSpeed;
				this.model.lunch = data[0].lunch;
				this.model.lunchMinutes = this.getDateWithSeconds(data[0].lunchMinutes);
				this.model.lunchInTruck = data[0].lunchInTruck;
				this.model.break = data[0].break;
				this.model.breakMinutes = this.getDateWithSeconds(data[0].breakMinutes);
				this.model.breakInTruck = data[0].breakInTruck;
				this.model.rescheduleDeliveries = data[0].rescheduleDeliveries;
				this.model.autoTransferAndClose = data[0].autoTransferAndClose || false;
				this.model.rescheduleHoldLocationId = data[0].rescheduleDeliveries && data[0].rescheduleHoldLocation ? {Key: data[0].rescheduleHoldLocation.id + ' | ' + data[0].rescheduleHoldLocation.name, Value: data[0].rescheduleHoldLocation.id} : null   
				data[1].results.map((b) => this.branch.push(b.branchId));
				branchDefer.resolve(this.model.branch);
			})
			.then(() => {
				this.loadRouteSequence();
				this.getAllTrucks();
				this.createRouteObjects();
				this.loadInternalLocations()
			})
			.catch((err) => {
				console.log(err);
			})

		branchDefer.promise
			.then((branch) => {
				this.getSetupDetails(branch)
				this.getAvailableTankers('', 0);
			})
			.finally(() => {
				this.loading = false;
			});
	}

	getSetupDetails(branch) {
		this.SetupService.get(branch)
			.then((setup) => {
				const date = this.DateUtil.convertToDate(setup.currentVaultDate);
				this.model.branchTimezone = setup.timezone;
				this.valutDate = moment(date).format('YYYY-MM-DD');
				this.branchOrigination = this.getOriginationPoint(setup, {
					id: branch,
					name: branch,
					address: setup.address,
					city: setup.city,
					state: setup.state,
					zip: setup.zip,
					lat: setup.gpsLat,
					long: setup.gpsLong
				});
				this.refreshOriginationMarker();
			})
			.catch((err) => {
				console.log(err);
			})
	}

	getDate = (time) => {
		if (!time) {
			return time;
		}

		time = time.split(':');

		let d = new Date();

		d.setHours(+time[0]);
		d.setMinutes(time[1]);
		d.setSeconds(0);
		d.setMilliseconds(0);

		return d;
	}

	getDateWithSeconds = (time) => {
		if (!time) {
			return time;
		}

		time = time.split(':');

		let d = new Date();

		d.setHours(+time[0]);
		d.setMinutes(time[1]);
		d.setSeconds(+time[2]);
		d.setMilliseconds(0);

		return d;
	}



	getUTCDate = (time) => {
		if (!time) return time;
	
		const [h, m] = time.split(':').map(Number);
	
		const d = new Date(Date.UTC(
			new Date().getUTCFullYear(),
			new Date().getUTCMonth(),
			new Date().getUTCDate(),
			h,
			m,
			0,
			0
		));
	
		return d;
	}

	getBranchTime(input, targetTz) {
		let utcMoment;
		if(!input) return input;
		if (input instanceof Date) {
			utcMoment = moment.utc(input);
		}
		else if (typeof input === 'string' && input.includes('GMT')) {
			utcMoment = moment.utc(new Date(input));
		}
		else {
			const todayUtc = moment.utc().format('YYYY-MM-DD');
			utcMoment = moment.utc(`${todayUtc}T${input}Z`);
		}
	
		return utcMoment
			.tz(targetTz)
			.toDate();
	}

	loadRouteSequence() {
		this.loadingRouteSequence = true;
		this.routePosition = 0;
		this.lat = 0;
		this.long = 0;
		this.totalLatLongLocations = 0;
		this.selectedLocations = [];
		const selectedDay = `defRouteSeq${this.selectedDay}`;

		this.Service.getRouteSequence(this.rawId, this.model.branch, this.selectedDay)
			.then((routeSequenceLocations) => {
				this.loadingRouteSequence = false;
				this.routeSequenceData = routeSequenceLocations;
				if (this.routeSequenceData.length) {
					this.routeSequenceData
						.sort((a, b) => a[selectedDay] - b[selectedDay])
						.forEach((data) => {
							this.selectedLocations.push({
								locationId: data.id,
								locationName: data.name,
							});
							if (data.lat && data.long) {
								this.totalLatLongLocations += 1;
								this.lat += data.lat;
								this.long += data.long;
							}
						});
				}
			})
			.then(() => {
				this.refreshSequenceInputs();
				this.getRouteSequenceData(this.routeSequenceData);
			})
			.catch((err) => {
				this.loadingRouteSequence = false;
				console.log(err);
			})
			.finally(() => {
				this.loadingRouteSequence = false;
			})
	}

	getRouteSequenceData(routeSequenceData) {
		this.routePosition = 0;
		this.centerLattitude = this.lat / this.totalLatLongLocations || 39.68649209557518;
		this.centerLongitude = this.long / this.totalLatLongLocations || -101.48273981764913;

		if (this.isInitialized) {
			this.map = L.map('map', {
				center: [this.centerLattitude, this.centerLongitude],
				zoom: 11
			});
			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
			}).addTo(this.map);
		}
		else {
			this.markerPosition.forEach((id) => {
				this.map.removeLayer(id)
			});
			this.markerPosition = [];
		}

		routeSequenceData.forEach((sequenceData) => {
			if (sequenceData && sequenceData.lat && sequenceData.long) {
				this.routePosition = _.findIndex(routeSequenceData, { id: sequenceData.id }) + 1;
				this.actualLat = sequenceData.lat;
				this.actualLong = sequenceData.long;
				this.locationInfo = '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip +
					'<br>' + sequenceData.city + ', ' + sequenceData.state;

				const id = L.marker([this.actualLat, this.actualLong],
					{
						icon: new L.AwesomeNumberMarkers({
							number: this.routePosition,
							markerColor: "blue"
						})
					})
					.addTo(this.map)
					.bindPopup(this.locationInfo)

				id.on('mouseover', function () {
					id.openPopup();
				});

				id.on('mouseout', function () {
					id.closePopup();
				});

				this.markerPosition.push(id);
			}
		})
		this.refreshOriginationMarker();
	}

	refreshSequenceInputs() {
		this.sequenceInput = this.routeSequenceData.map((location, position) => position + 1);
	}

	routeSequenceLocationMoved(index) {
		this.isInitialized = false;
		this.routeSequenceData.splice(index, 1);
		this.refreshSequenceInputs();
		this.getRouteSequenceData(this.routeSequenceData)
	}

	moveLocationToIndex(index, targetIndex) {
		const list = this.routeSequenceData;

		if (targetIndex < 0 || targetIndex >= list.length || targetIndex === index) {
			return this.refreshSequenceInputs();
		}

		this.isInitialized = false;
		list.splice(targetIndex, 0, list.splice(index, 1)[0]);
		this.refreshSequenceInputs();
		this.getRouteSequenceData(list);
	}

	moveLocation(index, offset) {
		this.moveLocationToIndex(index, index + offset);
	}

	sequenceTyped(index) {
		const typed = this.sequenceInput[index];

		if (typeof typed !== 'number' || isNaN(typed)) return this.refreshSequenceInputs();

		this.moveLocationToIndex(index, Math.round(typed) - 1);
	}

	selectDay(day) {
		this.reInitializeMap();
		this.selectedDay = day.value;
		this.currrentSelectedDay = `defRouteSeq${day.value}`;
		this.loadRouteSequence();
	}

	editLocation(location) {
		this.$state.go('location.edit', ({
			id: location.id
		}))
	}

	getSelectedDay() {
		let selectedDayLabel = '';
		this.days.some((day) => {
			if (day.value === this.selectedDay) {
				selectedDayLabel = day.label;
				return true
			}
		});
		return selectedDayLabel
	}

	routeTransferView() {
		this.isLoading = true;
		this.Modal.routeTransfer(this.$stateParams.id, this.$stateParams.day, this.valutDate, ({ modal, routeChangeData, routeChangeSequence, routeDay, routeSequence }) => {
			this.Service.routeLocTransfer(routeChangeData)
				.then((data) => {
					this.markerPosition.forEach((id) => {
						this.map.removeLayer(id)
					});
				})
				.then(() => {
					this.updateRoutePosition(routeSequence, routeChangeSequence, routeDay);
					this.reInitializeMap();
					this.isLoading = false;
				})
				.catch((err) => {
					console.log(err);
					this.isLoading = false;
				})
		}, ({ modal }) => {
			if (modal) modal.close();
			this.isLoading = false;
		})
	}

	updateRoutePosition(routeSequence, routeChangeSequence, routeDay) {
		this.Service.update(this.$stateParams.id, {
			day: routeDay,
			routeSequenceLocation: routeSequence.map(function (location) {
				return location.id
			}),
			routeSequenceLocationTwo: routeChangeSequence.map(function (location) {
				return location.id
			})
		})
			.then((data) => {
				this.loadRouteSequence()
			})
			.catch((err) => {
				console.log(err);
			})
	}

	reset() {
		this.getAvailableTankers('', 0);
		this.model = angular.copy(this.defaultModel);
		this.model.branch = this.User.getUser().branchId;
		this.model.loggedInUser = this.User.getUser().id;
		this.model.beginTime = this.getDate(this.model.beginTime);
		this.model.routeCutOffTime = this.getDate(this.model.routeCutOffTime);
		this.model.maxRouteTime = this.getDate(this.model.maxRouteTime);
		this.model.lunchMinutes = this.getDate(this.model.lunchMinutes);
		this.model.breakMinutes = this.getDate(this.model.breakMinutes);
		this.model.restrictTruck = this.defaultModel.restrictTruckId ? {
			Key: this.defaultModel.restrictTruck.id + ' | ' + this.defaultModel.restrictTruck.make, 
			Value: this.defaultModel.restrictTruckId,
			locationId: this.defaultModel.restrictTruck.locationId
		} : null
		this.currentlyAssignedTankers = {};
		this.isTankerAssignmentChanged = false;
		this.updatedTankerAssignment = {};
		this.model.rescheduleHoldLocationId = this.defaultModel.rescheduleHoldLocationId ? { 
			Key: this.defaultModel.rescheduleHoldLocation.id + ' | ' + this.defaultModel.rescheduleHoldLocation.name, 
			Value: this.defaultModel.rescheduleHoldLocationId 
		} : null
		this.refreshOriginationMarker();
	}

	submit(evt) {
		this.upsertTankerAssignment();
		this.loading = true;
		this.routeDays.forEach(route => this.model[route.value] = route.tick);

		this.Service.update(this.rawId, {
			id: this.rawId,
			name: this.model.name,
			shortName: this.model.shortName,
			active: this.model.active,
			beginTime: this.model.beginTime ? moment(this.model.beginTime).format('HH:mm:ss') : null,
			branchId: this.model.branch,
			holdRoute: this.model.holdRoute,
			loadTruck: this.model.loadTruck,
			description: this.model.description,
			requireDriver: this.model.requireDriver,
			requireGuard: this.model.requireGuard,
			specialFlag: this.model.specialFlag,
			uploadOnEndRouteOnly: this.model.uploadOnEndRouteOnly,
			autoOptimize: this.model.autoOptimize,
			autoOpenATMs: this.model.autoOpenATMs,
			bagoutFlag: this.model.bagoutFlag,
			requireLoadedAmount: this.model.requireLoadedAmount,
			requireResidualScan: this.model.requireResidualScan,
			requireBranchScan: this.model.requireBranchScan,
			requireThrow: this.model.requireThrow,
			eventRoute: this.model.eventRoute,
			shuttleRoute: this.model.shuttleRoute,
			liabilityLimit: this.model.liabilityLimit || null,
			day: this.selectedDay,
			routeSequenceLocation: this.routeSequenceData.map(function (location) {
				return location.id
			}),
			routeSequenceLocationTwo: [],
			vaultDate: this.valutDate,
			assignedTankers: this.assignedTankers,
			previouslyAssignedTanker: this.previouslyAssignedTanker,
			newAssignedTanker: this.newAssignedTanker,
			isTankerAssignmentChanged: this.isTankerAssignmentChanged,
			autoCheckIn: this.model.autoCheckIn,
			autoCheckOut: this.model.autoCheckOut,
			checkOutByTanker: this.model.checkOutByTanker,
			autoCheckInUpdate: this.model.autoCheckInUpdate,
			autoThrowOnPack: this.model.autoThrowOnPack,
			NFCScan: this.model.NFCScan,
			NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
			requireTruckScan: this.model.requireTruckScan,
			bagoutOnTruck: this.model.bagoutOnTruck,
			routeCutOff: this.model.routeCutOff,
			routeCutOffTime: this.model.routeCutOff && this.model.routeCutOffTime ? moment(this.model.routeCutOffTime).format('HH:mm:ss') : null,
			restrictToTruck: this.model.restrictToTruck,
			restrictTruckId: this.model.restrictToTruck && this.model.restrictTruck ? this.model.restrictTruck.id : null,
			optimizeAfterStop: this.model.optimizeAfterStop,
			autoSendPickupManifest: this.model.autoSendPickupManifest,
			pickupManifestRecipientEmail: this.model.pickupManifestRecipientEmail,
			origination: this.model.origination,
			routeMon: this.model.routeMon,
			routeTue: this.model.routeTue,
			routeWed: this.model.routeWed,
			routeThu: this.model.routeThu,
			routeFri: this.model.routeFri,
			routeSat: this.model.routeSat,
			routeSun: this.model.routeSun,
			routeHol: this.model.routeHol,
			sendRouteSheet: this.model.sendRouteSheet,
			routeSheetRecipients: this.model.sendRouteSheet ? this.model.routeSheetRecipients : null,
			timezone: this.model.branchTimezone,
			scanUserItems: this.model.scanUserItems,
			maxRouteTime: this.model.maxRouteTime ? moment(this.model.maxRouteTime).format('HH:mm:ss') : null,
			maxMileage: this.model.maxMileage,
			estimatedRouteSpeed: this.model.estimatedRouteSpeed,
			lunch: this.model.lunch,
			lunchMinutes: (this.model.lunch && this.model.lunchMinutes) ? moment(this.model.lunchMinutes).format('00:mm:ss') : null,
			lunchInTruck: this.model.lunch ? this.model.lunchInTruck : false,
			break: this.model.break,
			breakMinutes: (this.model.break && this.model.breakMinutes) ? moment(this.model.breakMinutes).format('00:mm:ss') : null,
			breakInTruck: this.model.break ? this.model.breakInTruck : false,
			rescheduleDeliveries: this.model.rescheduleDeliveries,
			autoTransferAndClose: this.model.autoTransferAndClose,
			rescheduleHoldLocationId: this.model.rescheduleDeliveries && this.model.rescheduleHoldLocationId ? this.model.rescheduleHoldLocationId.Value : null
		})
			.then((data) => {
				this.loading = false
				// this.$state.go('routeControl')
				window.history.go(-1)
			})
			.catch((err) => {
				this.loading = false
				const errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'ROUTE.NFCTagId') {
					this.errorMessage = this.$translate.instant('common.unique_nfc_tag_id');
				}
				else if (err && err.data && err.data.message) {
					this.errorMessage += err.data.message + '<br/>'
				}
				else {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
			})
	}

	getAvailableTankers(searchKey, offset) {
		this.dayArray = [], this.total = [];
		this.Service.getTankersAvailable(this.rawId)
			.then((res) => {
				this.model.tankers = res;
				this.weekdays.forEach((d, index) => {
					if (offset == 0 || offset == undefined) {
						this.total.push({
							[d.value]: {
								total: res[d.day].length
							}
						});
						this.dayArray.push({
							[d.value]: this.mapRouteTankers(res[d.day], searchKey, d.day)
						})
						this.dayArray[index][d.value].filter((data) => {
							if (data.Selected) {
								this.model[d.value].tankerId = data;
								Object.assign(this.currentlyAssignedTankers, new Object({ [d.value]: this.model[d.value].tankerId.Value }))
							}
						})
					}
				})
			})
			.catch((err) => {
				console.log(err);
			})
	}

	mapRouteTankers(mapArray, searchKey, day) {
		return mapArray.map((obj) => {
			return {
				Key: obj.tankerId + ' | ' + obj.name,
				Value: obj.tankerId,
				Selected: obj.selected,
				dayOfWeek: day
			}
		});
	}

	sameForAll() {
		this.contractDays = [];
		this.weekdays.forEach((data) => {
			this.contractDays[data.value] = data;
		})

		if (this.model.sameForAll) {
			this.assignedTankers = {};
			for (let day in this.contractDays) {
				if (this.contractDays[day]) {
					for (let key in this.model[day]) {
						this.model[day][key] = ''
					}
				}
			}
		}
		this.findTankerAssignmentChange();
	}

	updateAll(selectedDay, opt, weekday) {
		this.assignedTankers = {};
		if (this.model.sameForAll) {
			if (this.contractDays[selectedDay]) {
				for (let day in this.contractDays) {
					if (this.contractDays[day] && this.model[selectedDay][opt]) {
						this.dayArray.filter((d) => {
							if (_.find(d[day], { Value: this.model[selectedDay][opt].Value })) {
								this.model[day].tankerId = this.model[selectedDay][opt]
							}
						})
					}
				}
			}
		}
		this.weekdays.forEach((day, index) => {
			if (this.model[day.value].tankerId) {
				this.model[day.value].tankerId.dayOfWeek = day.day;
				this.model[day.value].tankerId.Selected = 1;

				this.dayArray.filter((d) => {
					if (_.find(d[day.value], { Value: this.model[day.value].tankerId.Value })) {
						this.assignedTankers[this.model[day.value].tankerId.dayOfWeek] = this.model[day.value].tankerId.Value
					}
				})
			}
		})
		this.findTankerAssignmentChange();
	}

	assignTankers() {
		this.weekdays.forEach((day, index) => {
			if (this.model[day.value].tankerId) {
				this.assignedTankers[this.model[day.value].tankerId.dayOfWeek] = this.model[day.value].tankerId.Value
			}
		})
		// console.log(this.assignedTankers);
	}

	// (remove below two functions if you want new logic as per card #3451)
	upsertTankerAssignment() {
		if (this.model.requireThrow) {
			this.assignTankers();
			this.findTankerAssignmentChange();
		}
		else this.assignedTankers = {};
	}

	resetTankerAssignment() {
		this.weekdays.forEach((d, index) => {
			if (this.model[d.value]) this.model[d.value].tankerId = null;
		})
	}

	// (uncomment a below two functions if you want new logic as per card #3451)
	// upsertTankerAssignment() {
	// 	if (this.model.requireThrow || this.model.checkOutByTanker) {
	// 		this.assignTankers();
	// 		this.findTankerAssignmentChange();
	// 	}
	// 	else this.assignedTankers = {};
	// }

	// resetTankerAssignment() {
	// 	if (!this.model.requireThrow && !this.model.checkOutByTanker) {
	// 		this.weekdays.forEach((d, index) => {
	// 			if (this.model[d.value]) this.model[d.value].tankerId = null;
	// 		})
	// 	}
	// }

	reInitializeMap() {
		this.removeOriginationMarker();
		this.map.remove();
		this.isInitialized = true;
		this.markerPosition.forEach((id) => {
			this.map.removeLayer(id)
		});
		this.markerPosition = [];
	}

	findDifference(object, base) {
		return _.transform(object, (result, value, key) => {
			if (!_.isEqual(value, base[key])) {
				result[key] = _.isObject(value) && _.isObject(base[key]) ? this.findDifference(value, base[key]) : value;
			}
		});
	}

	findTankerAssignmentChange() {
		this.updatedTankerAssignment = {};
		this.createRecords = [];
		this.updateRecords = [];
		this.deleteRecords = [];
		this.dayOfWeekObj = { 'Sun': 1, 'Mon': 2, 'Tue': 3, 'Wed': 4, 'Thu': 5, 'Fri': 6, 'Sat': 7 };

		this.weekdays.forEach((day, index) => {
			if (this.model[day.value].tankerId) Object.assign(this.updatedTankerAssignment, new Object({ [day.value]: this.model[day.value].tankerId.Value }))
		})

		this.previouslyAssignedTanker = this.findDifference(this.currentlyAssignedTankers, this.updatedTankerAssignment);
		this.newAssignedTanker = this.findDifference(this.updatedTankerAssignment, this.currentlyAssignedTankers);

		if (!_.isEmpty(this.previouslyAssignedTanker) || !_.isEmpty(this.newAssignedTanker)) this.isTankerAssignmentChanged = true;
		else this.isTankerAssignmentChanged = false;

		for (let [newKey, newValue] of Object.entries(this.newAssignedTanker)) {
			if (this.previouslyAssignedTanker[newKey] === undefined) {
				this.createRecords.push({ dayOfWeek: this.dayOfWeekObj[newKey], tankerId: newValue });
			}
		}

		for (let [oldKey, oldValue] of Object.entries(this.previouslyAssignedTanker)) {
			if (this.newAssignedTanker[oldKey] === undefined) {
				this.deleteRecords.push({ dayOfWeek: this.dayOfWeekObj[oldKey], tankerId: oldValue });
			}
		}

		for (let [oldKey, oldValue] of Object.entries(this.previouslyAssignedTanker)) {
			for (let [newKey, newValue] of Object.entries(this.newAssignedTanker)) {
				if ((oldKey === newKey) && (this.previouslyAssignedTanker[oldKey] != this.newAssignedTanker[newKey])) {
					this.updateRecords.push({ dayOfWeek: this.dayOfWeekObj[newKey], tankerId: newValue });
				}
			}
		}

		for (let [newKey, newValue] of Object.entries(this.newAssignedTanker)) {
			Object.assign(this.newAssignedTanker, new Object({ [newKey]: newValue + ' | ' + newKey }))
		}

		for (let [oldKey, oldValue] of Object.entries(this.previouslyAssignedTanker)) {
			Object.assign(this.previouslyAssignedTanker, new Object({ [oldKey]: oldValue + ' | ' + oldKey }))
		}
	}

	saveLater() {
		this.findTankerAssignmentChange();

		const tankerAssignment = {
			previouslyAssignedTanker: Object.values(this.previouslyAssignedTanker),
			newAssignedTanker: Object.values(this.newAssignedTanker),
			isTankerAssignmentChanged: this.isTankerAssignmentChanged,
			// assignedTankers: this.assignedTankers,
			key: 'update_tanker_assignment',
			createRecords: this.createRecords,
			updateRecords: this.updateRecords,
			deleteRecords: this.deleteRecords
		}

		const extraDetails = {
			branchId: this.model.branch,
			routeName: this.model.name,
			userId: this.model.loggedInUser,
			username: this.User.getUser().firstName.concat(' ', this.User.getUser().lastName)
		}

		this.Modal.saveRouteChangesLaterModal(tankerAssignment, this.rawId, ({ modal, duration, dateTime }) => {
			tankerAssignment.executeAt = tankerAssignment.isTankerAssignmentChanged ? dateTime : null;
			const routeDetailsObj = tankerAssignment.isTankerAssignmentChanged ? tankerAssignment : {};

			this.Service.saveRouteChanges(this.rawId, routeDetailsObj, extraDetails, duration)
				.then(() => window.history.go(-1))
				.catch(err => {
					console.log(err);
					this.Modal.errorModal(err.data.message);
				})
		}, ({ modal }) => {
			if (modal) modal.close();
		});
	}

	getPendingRouteChanges() {
		return this.Service.getPendingRouteChanges(this.$stateParams.id)
			.then((data) => {
				this.pendingRouteChanges = data;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	removeRouteChanges(jobId) {
		return this.Service.removeRouteChanges(jobId)
			.then(() => {
				this.getPendingRouteChanges();
			})
			.catch((err) => {
				console.log(err);
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message);
				}
			})
	}

	confirmDelete(jobId) {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('common.confirm_delete_message'),
			callback: (({
				modal
			}) => {
				this.removeRouteChanges(jobId);
				modal.close();
			}),
			negative: (({
				modal,
			}) => {
				modal.close();
			}),
			type: 'danger'
		})
	}

	translateMessage(key) {
		if (!key) return;
		return this.$translate.instant('route.' + key);
	}

	validateToggles() {
		this.model.autoThrowOnPack = this.model.requireThrow ? this.model.autoThrowOnPack : false;
	}

	printLocationBarcodes() {
		const obj = {
			selectedLocations: this.selectedLocations
		}

		const path = this.$state.href('printLocationBarcodes');
		window.w = window.open(path, '_blank');
		window.w.printData = obj;
	}

	getAllTrucks(){
		this.TruckService.getRestrictTrucks('', this.model.branch, null, 1000, 0)
		.then((data) => {
			this.truckOptions.totalRecords = data.total;
			this.truckOptions.options = this.mappingTruckData(data.results, '');
		})
	}

	mappingTruckData = (trucks) => {
		trucks.map((truck) => {
			truck.Key = truck.id + " | " + truck.make;
			truck.Value = truck.id;
		});
		return trucks;
	}

	getOriginationPoint(source, fallback = {}) {
		if (!source) return null;

		const lat = source.lat !== undefined && source.lat !== null ? source.lat : (source.gpsLat !== undefined && source.gpsLat !== null ? source.gpsLat : fallback.lat);
		const long = source.long !== undefined && source.long !== null ? source.long : (source.gpsLong !== undefined && source.gpsLong !== null ? source.gpsLong : fallback.long);

		if (lat === null || lat === undefined || long === null || long === undefined) {
			return null;
		}

		return {
			id: source.id || fallback.id,
			name: source.name || fallback.name,
			address: source.address || fallback.address || '',
			city: source.city || fallback.city || '',
			state: source.state || fallback.state || '',
			zip: source.zip || fallback.zip || '',
			lat: Number(lat),
			long: Number(long)
		};
	}

	getTargetDate() {
		const dayOfWeekMap = {
			'Sun': 0,
			'Mon': 1,
			'Tue': 2,
			'Wed': 3,
			'Thu': 4,
			'Fri': 5,
			'Sat': 6
		};

		if (this.selectedDay && this.selectedDay in dayOfWeekMap) {
			const date = moment(this.valutDate, 'YYYY-MM-DD').day(dayOfWeekMap[this.selectedDay]).format('YYYY-MM-DD');
			return this.$q.resolve(date);
		}

		return this.$q.resolve(this.valutDate);
	}

	removeOriginationMarker() {
		if (this.map && this.originationMarker) {
			this.map.removeLayer(this.originationMarker);
		}

		this.originationMarker = null;
	}

	getRouteBounds(originationLocation = null) {
		const points = [];

		this.routeSequenceData.forEach((location) => {
			if (location && location.lat !== null && location.lat !== undefined && location.long !== null && location.long !== undefined) {
				points.push([Number(location.lat), Number(location.long)]);
			}
		});

		if (originationLocation) {
			points.push([Number(originationLocation.lat), Number(originationLocation.long)]);
		}

		return points.length ? L.latLngBounds(points) : null;
	}

	updateMapBounds(originationLocation = null) {
		if (!this.map) {
			return;
		}

		const bounds = this.getRouteBounds(originationLocation);
		if (!bounds) {
			return;
		}

		if (bounds.isValid()) {
			this.map.fitBounds(bounds, { padding: [30, 30] });
		}
	}

	addOriginationMarker(location, label) {
		if (!this.map || !location) {
			return;
		}

		this.removeOriginationMarker();

		const cityState = [location.city, location.state].filter(Boolean).join(', ');
		const details = [location.address, location.zip].filter(Boolean).join(' - ');
		const popupParts = [`<strong>${label}: ${location.name || location.id}</strong>`];

		if (details) {
			popupParts.push(details);
		}

		if (cityState) {
			popupParts.push(cityState);
		}

		this.originationMarker = L.marker([location.lat, location.long], {
			icon: new L.AwesomeNumberMarkers({
				number: label.charAt(0).toUpperCase(),
				markerColor: "black"
			})
		})
			.addTo(this.map)
			.bindPopup(popupParts.join('<br>'));

		this.originationMarker.on('mouseover', function () {
			this.openPopup();
		});

		this.originationMarker.on('mouseout', function () {
			this.closePopup();
		});

		this.updateMapBounds(location);
	}

	refreshOriginationMarker() {
		if (!this.map) {
			return;
		}

		if (this.model.origination === 'BRANCH') {
			this.addOriginationMarker(this.branchOrigination, 'Branch');
			return;
		}

		if (this.model.origination === 'USER') {
			if (this.selectedDay === 'Hol') {
				if (this.branchOrigination) {
					this.addOriginationMarker(this.branchOrigination, 'Branch');
				} else {
					this.removeOriginationMarker();
					this.updateMapBounds();
				}
				return;
			}

			if (!this.valutDate) {
				this.removeOriginationMarker();
				this.updateMapBounds();
				return;
			}

			const requestId = ++this.originationLocationRequest;
			this.getTargetDate()
				.then((targetDate) => {
					if (requestId !== this.originationLocationRequest) return;

					const routeSearchObj = {
						queryJSON: {
							rules: [
								{ field: "branchId", condition: "=", data: this.model.branch },
								{ field: "routeId", condition: "=", data: this.$stateParams.id },
								{ field: "routeDate", condition: "=", data: targetDate }
							],
							operator: 'AND'
						}
					};

					return this.RouteDetailService.all(routeSearchObj, 0, 1)
						.then((data) => {
							if (requestId !== this.originationLocationRequest) return;
							const messenger = data && data.results && data.results[0] && data.results[0].messenger;
							const isUserOriginMismatch = messenger && messenger.userOrigin && messenger.userOrigin !== 'USER';
							const userOrigination = messenger && !isUserOriginMismatch ? this.getOriginationPoint(messenger, {
								name: `${messenger.firstName} ${messenger.lastName}`
							}) : null;

							if (userOrigination) {
								this.addOriginationMarker(userOrigination, 'User');
							} else {
								// Fallback to branch marker if messenger is not assigned on this day or mismatch exists
								if (this.branchOrigination) {
									this.addOriginationMarker(this.branchOrigination, 'Branch');
								} else {
									this.removeOriginationMarker();
									this.updateMapBounds();
								}
							}
						});
				})
				.catch((err) => {
					console.log(err);
					if (requestId === this.originationLocationRequest) {
						// Fallback to branch marker on error
						if (this.branchOrigination) {
							this.addOriginationMarker(this.branchOrigination, 'Branch');
						} else {
							this.removeOriginationMarker();
							this.updateMapBounds();
						}
					}
				});
			return;
		}

		if (this.model.origination === 'TRUCK') {
			let restrictTruck = this.model.restrictTruck;
			// Handle case where restrictTruck might be just the ID (string/number)
			if (restrictTruck && (typeof restrictTruck === 'string' || typeof restrictTruck === 'number')) {
				restrictTruck = _.find(this.truckOptions.options, { Value: restrictTruck }) || 
							   _.find(this.truckOptions.options, { id: restrictTruck });
			}

			if (!this.model.restrictToTruck || !restrictTruck || !restrictTruck.locationId) {
				this.removeOriginationMarker();
				this.updateMapBounds();
				return;
			}
			const requestId = ++this.originationLocationRequest;
			this.LocationService.get(restrictTruck.locationId)
				.then((location) => {
					if (requestId !== this.originationLocationRequest) {
						return;
					}

					const truckOrigination = this.getOriginationPoint(location, {
						id: restrictTruck.id || restrictTruck.Value,
						name: restrictTruck.make || restrictTruck.Key,
						lat: restrictTruck.lat || restrictTruck.gpsLat,
						long: restrictTruck.long || restrictTruck.gpsLong
					});

					if (truckOrigination) {
						this.addOriginationMarker(truckOrigination, 'Truck');
					} else {
						this.removeOriginationMarker();
						this.updateMapBounds();
					}
				})
				.catch((err) => {
					if (requestId === this.originationLocationRequest) {
						const truckOrigination = this.getOriginationPoint(restrictTruck);
						if (truckOrigination) {
							this.addOriginationMarker(truckOrigination, 'Truck');
						} else {
							this.removeOriginationMarker();
							this.updateMapBounds();
						}
					}
				});
			return;
		}

		// Fallback for null / undefined / None
		this.removeOriginationMarker();
		this.updateMapBounds();
	}

	createRouteObjects() {
		this.routeDays = this.routeDays.map((route, index) => ({
			key: this.$translate.instant(`location.${this.dayKeys[index].toLowerCase()}`),
			value: route,
			tick: this.defaultModel[route],
		}));
	}

	isDaySelected(day) {
		day.tick = !day.tick;
	}

	loadInternalLocations(searchKey, offset) {
		searchKey = searchKey || '';

		const locationSearchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: '=',
					data: this.model.branch
				},
				{
					field: 'locationType',
					condition: '=',
					data: 'INTERNAL'
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			},
		}

		this.isLoadingInternalLocations = true;
		this.LocationService.getAllLocation(locationSearchObj, offset, this.AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.internalLocationsObj.totalRecords = data.total;
					this.internalLocationsObj.results = this.locMapping(data.results);
				} else {
					const locations = this.locMapping(data.results);
					this.internalLocationsObj.results = this.internalLocationsObj.results.concat(locations);
				}
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.isLoadingInternalLocations = false;
			})
	}

	locMapping(locations) {
		return locations.map((l) => {
			return {
				Key: l.id + " | " + l.name,
				Value: l.id
			}
		});
	}

	resetRescheduleHoldLocation() {
		this.model.rescheduleHoldLocationId = null;
	}

	branchChanged() {
		this.resetRescheduleHoldLocation();
		this.loadInternalLocations('', 0);
		this.getSetupDetails(this.model.branch);
	}

	restrictToTruckChanged() {
		this.refreshOriginationMarker();
		if (!this.model.restrictToTruck) {
			this.model.restrictTruck = null;
			this.restrictTruckAddress = null;
		} else {
			this.restrictTruckChanged();
		}
	}

	originationChanged() {
		this.refreshOriginationMarker();
	}

	restrictTruckChanged() {
		this.refreshOriginationMarker();
		this.restrictTruckAddress = null;
		let restrictTruck = this.model.restrictTruck;
		if (restrictTruck && (typeof restrictTruck === 'string' || typeof restrictTruck === 'number')) {
			restrictTruck = _.find(this.truckOptions.options, { Value: restrictTruck }) || 
						   _.find(this.truckOptions.options, { id: restrictTruck });
		}
		if (restrictTruck && restrictTruck.locationId) {
			this.LocationService.get(restrictTruck.locationId)
				.then((location) => {
					if (location.address || location.city || location.state || location.zip) {
						this.restrictTruckAddress = `${location.address || ''}, ${location.city || ''}, ${location.state || ''} ${location.zip || ''}`;
					} else {
						this.restrictTruckAddress = null;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}

}

export default RoutesEditController;



// WEBPACK FOOTER //
// ./client/app/components/routes/edit/routes.edit.controller.js